import { useFeatureGate } from '@trello/feature-gate-client';
import { intl } from '@trello/i18n';

import { useDocumentTitle } from 'app/src/components/DocumentTitle';
import { MemberHomeProfileTabContainer } from 'app/src/components/MemberHome/MemberHomeProfileTab/MemberHomeProfileTabContainer';
import { WorkspacePageHeader } from 'app/src/components/WorkspacePages/WorkspacePageHeader';

import styles from './MemberProfileView.less';

export const MemberProfileView = () => {
  const { value: isBillplatWorkspaceSettingsEnabled } = useFeatureGate(
    'billplat_workspace_settings_navigation',
  );

  useDocumentTitle(
    intl.formatMessage({
      id: 'page title.profile',
      defaultMessage: 'Profile',
      description: 'Profile',
    }),
  );

  return (
    <div className={styles.profilePageContainer}>
      {isBillplatWorkspaceSettingsEnabled && (
        <WorkspacePageHeader
          title={intl.formatMessage({
            id: 'page title.profile',
            defaultMessage: 'Profile',
            description: 'Profile',
          })}
        />
      )}
      <MemberHomeProfileTabContainer />
    </div>
  );
};
